/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import { ToastsStore } from 'react-toasts';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
// import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import LoadingIndicator from '../../View/LoadingIndicator';
import history from '../../utils/history';
import api from '../../utils/api';
import { GET_STUDENT_SCHEDULE, SUBMIT_EARLY_LEAVE } from '../../utils/apiEndPoint';
import { errMsg, formatMessage } from '../../utils/messages';

const Form = ({ setShowEarlyLeaveForm, reasons }) => {
  const [leaveDate, setLeaveDate] = useState('');
  const [periods, setPeriods] = useState([]);
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');
  const [alternatePhone, setAlternatePhone] = useState('');
  const [releaseTime, setReleaseTime] = useState(dayjs(''));
  const [releaseTimeValue, setReleaseTimeValue] = useState('');
  const [periodsData, setPeriodsData] = useState([]);
  const [periodsDataStatusCode, setPeriodsDataStatusCode] = useState(0);
  const [isClickedOnce, setIsClickedOnce] = useState(false);

  // loader
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  // error
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [periodsDataError, setPeriodsDataError] = useState('');

  // storage
  const userConfig = JSON.parse(sessionStorage.getItem('login_details'));
  const token = sessionStorage.getItem('token');

  const getStudentPeriods = () => {
    const { studentId } = userConfig;
    // const url = `${GET_STUDENT_SCHEDULE}/120743`; // url with student id to get student schedule
    const url = `${GET_STUDENT_SCHEDULE}/${studentId}`;
    api.get(url)
      .then((response) => {
        if (response.status === 200) {
          setPeriodsData(response.data);
          setPeriodsDataError('');
          setPeriodsDataStatusCode(0);
        } else if (response.status === 404) {
          setPeriodsDataError(response.msg);
          setPeriodsDataStatusCode(response.status);
        } else {
          setPeriodsDataError(errMsg);
          setPeriodsDataStatusCode(response.status);
        }
        setLoading(false);
      }).catch((error) => {
        if (error) {
          setLoading(false);
          setPeriodsDataError(errMsg);
        }
      });
  };

  useEffect(() => {
    getStudentPeriods();
  }, []);

  const onChangeLeaveDate = (jsDate, dateString) => {
    setLeaveDate(dateString);
    setErrors({ ...errors, leaveDate: '' });
  };

  const onChangePeriods = (e) => {
    const options = periods;
    setErrors({ ...errors, periods: '' });
    let index;
    const selectAll = document.querySelector('#select_all');
    selectAll.checked = false;
    document.getElementById('s_all').innerHTML = 'Select All';
    // check if the check box is checked or unchecked
    if (periods.length === 0 && !isClickedOnce) {
      const allCheckboxInRecordList = document.forms.earlyform.getElementsByTagName('input');
      for (const checkbox of allCheckboxInRecordList) {
        const field = checkbox;
        if (field.type === 'checkbox' && !field.disabled && field.value !== '' && e.target.value < field.value) {
          field.checked = true;
          if (options.indexOf(field.value) !== -1) {
            console.log('Value exists!');
          } else {
            options.push(field.value);
          }
        }
      }
      setIsClickedOnce(true);
    }
    if (e.target.checked) {
      // add the numerical value of the checkbox to options array
      if (options.indexOf(e.target.value) !== -1) {
        console.log('Value exists!');
      } else {
        options.push(e.target.value);
      }
    } else {
      // or remove the value from the unchecked checkbox from the array
      index = options.indexOf(e.target.value);
      options.splice(index, 1);
    }
    // update the state with the new array of options
    setPeriods(options);
    if (periodsData.length === periods.length) {
      selectAll.checked = true;
      document.getElementById('s_all').innerHTML = 'Unselect All';
    }
  };

  const onChangeReason = (e) => {
    setReason(e.target.value);
    setErrors({ ...errors, reason: '' });
  };

  const onChangeReleseTime = (val) => {
    setReleaseTimeValue(val ? val.format('h:mm A') : val);
    setReleaseTime(val);
    setErrors({ ...errors, releaseTime: '' });
  };

  const onChangeAlternatePhone = (event) => {
    const re = /^[0-9\b]+$/;
    if (re.test(event)) {
      setAlternatePhone(event);
    }
    if (event === '') {
      setAlternatePhone(event);
      setErrors({ ...errors, alternatePhone: '' });
    }
    if (event.length > 0 && event.length === 10) {
      setErrors({ ...errors, alternatePhone: '' });
    }
  };

  const onClickSelectAllPeriods = () => {
    setErrors({ ...errors, periods: '' });
    const checkboxes = document.getElementById('select_all');
    let i;
    const allCheckboxInRecordList = document.forms.earlyform.getElementsByTagName('input');
    const options = periods;
    let index;
    if (checkboxes.checked) {
      checkboxes.checked = true;
      for (i = 0; i < allCheckboxInRecordList.length; i += 1) {
        const field = allCheckboxInRecordList[i];
        if (field.type === 'checkbox' && !field.disabled && field.value !== '') {
          field.checked = true;
          document.getElementById('s_all').innerHTML = 'Unselect All';
          if (options.indexOf(field.value) !== -1) {
            console.log('Value exists!');
          } else {
            options.push(field.value);
          }
        }
      }
    } else {
      checkboxes.checked = false;
      for (i = 0; i < allCheckboxInRecordList.length; i += 1) {
        const field1 = allCheckboxInRecordList[i];
        if (field1.type === 'checkbox' && !field1.disabled && field1.value !== '') {
          field1.checked = false;
          document.getElementById('s_all').innerHTML = 'Select All';
          index = options.indexOf(field1.value);
          options.splice(index, 1);
        }
      }
    }
  };

  const handleValidation = () => {
    const errorsObj = {};
    let formIsValid = true;

    if (!leaveDate) {
      formIsValid = false;
      errorsObj.leaveDate = 'Please select Leave Date';
    } else {
      const dateRegex = new RegExp('\\d{1,2}\\/\\d{1,2}\\/\\d{4}$');
      if (!leaveDate.match(dateRegex)) {
        formIsValid = false;
        errorsObj.leaveDate = 'Please select valid Leave Date';
      }
    }

    if (periods.length === 0) {
      formIsValid = false;
      errorsObj.periods = 'Must select atleast one';
    }
    if (!reason) {
      formIsValid = false;
      errorsObj.reason = 'Must select atleast one';
    }
    if (alternatePhone && alternatePhone.length > 0 && alternatePhone.length < 10) {
      formIsValid = false;
      errorsObj.alternatePhone = 'Enter valid Phone Number';
    }
    if (releaseTime) {
      if (releaseTime.$d.toString() === 'Invalid Date') {
        formIsValid = false;
        if (releaseTimeValue === '') {
          errorsObj.releaseTime = 'Please select Release Time';
        } else {
          errorsObj.releaseTime = 'Please select valid Release Time';
        }
      }
    } else {
      formIsValid = false;
      errorsObj.releaseTime = 'Please select Release Time';
    }
    setErrors(errorsObj);
    return formIsValid;
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    if (handleValidation()) {
      const { studentId } = userConfig;

      const userEarlyLeaveData = {
        token,
        student_id: studentId,
        early_leave_code: reason,
        alternate_phone: alternatePhone,
        release_time: releaseTimeValue,
        comments,
        leave_date: leaveDate,
        period: periods.sort(),
      };

      setSubmitLoading(true);

      api.post(SUBMIT_EARLY_LEAVE, userEarlyLeaveData)
        .then((response) => {
          if (response.status === 200) {
            setSubmitLoading(false);
            ToastsStore.success(response.msg);
            history.push({
              pathname: '/thankyou',
              state: {
                msg: 'Your Early Leave submission has been received. The ECRCHS Attendance Team is currently processing your request.',
                btnText: 'Submit Another Request',
                path: window.location.pathname,
                logout: true,
              },
            });
          } else if (response.status === 422) {
            setSubmitLoading(false);
            setSubmitError(formatMessage(response.msg));
          } else {
            setSubmitLoading(false);
            setSubmitError(response.msg);
          }
        }).catch((error) => {
          if (error) {
            setSubmitLoading(false);
            setSubmitError(errMsg);
          }
        });
    } else {
      console.log('Form has errors.');
    }
  };

  const clearAbsenceButton = (
    <Link
      className="btn"
      to="#"
      onClick={() => setShowEarlyLeaveForm(false)}
    >
      <FontAwesomeIcon icon={faArrowAltCircleLeft} />
      {' '}
      Clear an Absences
    </Link>
  );

  if (loading || periodsDataError) {
    return (
      <section className="content ea_box early-leave-section header-error">
        <div className="header-wrapper">
          {loading && (<LoadingIndicator />)}
          {(!loading && periodsDataError) && (
          <>
            <p style={{
              color: periodsDataStatusCode !== 404 && periodsDataStatusCode !== 0 ? 'red' : '#676767',
              marginTop: 10,
            }}
            >
              {periodsDataError}
            </p>
            {clearAbsenceButton}
          </>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="content ea_box early-leave-section">
      <div className="header-wrapper">
        <h2 className="header-title">
          early leave
        </h2>
        {clearAbsenceButton}
      </div>
      <form
        method="post"
        className="earlyform"
        name="earlyform"
      >
        <div
          id="calendar_container"
          className="date_picker early_leave_calendar form-row show-selectnav show-week hide-btnrow"
        >
          <h3 style={{ color: '#7cc576', fontSize: '18px' }}>
            Requested Leave Date
            {' '}
            <span
              className="required"
              style={{ color: 'red', fontSize: 12 }}
            >
              *
            </span>
          </h3>
          <h6>(Starting from today)</h6>
          <DatePickerInput
            id="leave_date"
            onChange={onChangeLeaveDate}
            value={leaveDate}
            autoComplete="off"
            className="my-custom-datepicker-component"
            required
            placeholder="mm/dd/yyyy"
            onClear={() => setLeaveDate('')}
            returnFormat="MM/DD/YYYY"
            showOnInputClick
            minDate={Date.now()}
          />
          {errors.leaveDate && (
          <span style={{ color: 'red', fontSize: 12 }}>
            {errors.leaveDate}
          </span>
          )}
        </div>
        <div className="column">
          <h3>
            Periods
            {' '}
            <span
              className="required"
              style={{ color: 'red', fontSize: 12 }}
            >
              *
            </span>
          </h3>
          <h6>
            Please select all periods that you will be absent on
            the selected date. Multiple periods can be selected.
          </h6>
          <ul>
            {periodsData.map((val) => (
              <li key={val.name}>
                <input
                  type="checkbox"
                  id={val.name}
                  onChange={onChangePeriods}
                  className="period_checkbox "
                  name="period[]"
                  value={val.value}
                />
                <label htmlFor={val.name}>
                  {val.label}
                  {' '}
                  <span>{val.name}</span>
                </label>
              </li>
            ))}
            <li>
              <input
                type="checkbox"
                id="select_all"
                name="select_all"
                onChange={onClickSelectAllPeriods}
                className="period_checkbox select_all"
                value=""
              />
              <label htmlFor="select_all">
                Select All
                <span id="s_all">Select All</span>
              </label>
            </li>
          </ul>
          {errors.periods && (
          <span style={{ color: 'red', fontSize: 12 }}>
            {errors.periods}
          </span>
          )}
        </div>
        <div className="column reasons_position ">
          <h3>
            Reason
            {' '}
            <span
              className="required"
              style={{ color: 'red', fontSize: 12 }}
            >
              *
            </span>
          </h3>
          <h6>
            You are only allowed to choose one reason,
            even if you require to leave for more than one reason.
          </h6>
          <ul>
            {reasons.map((res) => (
              <li key={res.value}>
                <input
                  type="radio"
                  id={res.label}
                  name="reason"
                  value={res.value}
                  onChange={onChangeReason}
                  required
                />
                <label htmlFor={res.label}>{res.label}</label>
              </li>
            ))}

          </ul>
          {errors.reason && (
          <span style={{ color: 'red', fontSize: 12 }}>
            {errors.reason}
          </span>
          )}
        </div>

        {/* <div className="column column_full">
        <div className="left_input">
          <h3>
            Parent Name
            {' '}
            <span
              className="required"
              style={{ color: 'red', fontSize: 12 }}
            >
              *
            </span>
          </h3>
          <div className="mac-input-box">
            <h5>First Name</h5>
            <input
              id="first_name"
              maxLength="50"
              className="ecr-input"
              name="first_name"
              onChange={(e) => {
                if (!/[^a-zA-Z]/.test(e.target.value)) {
                  set_first_name(e.target.value);
                  errors.first_name = '';
                }
              }}
              value={first_name}
            />
            <span style={{ color: 'red', fontSize: 12 }}>
              {errors.first_name}
            </span>
          </div>
          <div className="mac-input-box">

            <h5>Last Name</h5>
            <input
              id="last_name"
              maxLength="50"
              className="ecr-input"
              name="last_name"
              onChange={(e) => {
                if (!/[^a-zA-Z]/.test(e.target.value)) {
                  set_last_name(e.target.value);
                  errors.last_name = '';
                }
              }}
              value={last_name}
            />
            <span style={{ color: 'red', fontSize: 12 }}>{errors.last_name}</span>
          </div>
        </div>
        <div className="right_input">
          <h3>
            Relationship
            {' '}
            <span className="required" style={{ color: 'red', fontSize: 12 }}>*</span>
          </h3>
          <ul>
            {relationship.map((res) => (
              <li key={res.value}>
                <input
                  type="radio"
                  id={res.label}
                  name="relationships"
                  value={res.value}
                  onChange={
                        (e) => {
                          setRelationships(e.target.value);
                          errors.other = '';
                          errors.relationships = '';
                        }
                    }
                />
                <label htmlFor={res.label}>{res.label}</label>
              </li>
            ))}
          </ul>
          <span style={{ color: 'red', fontSize: 12 }}>
            {errors.relationships}
          </span>
          {relationships === 'Other' ? (
            <input
              id="other"
              className="ecr-input"
              name="other"
              maxLength="50"
              onChange={(e) => {
                if (!/[^a-zA-Z]/.test(e.target.value)) {
                  setOther(e.target.value);
                  errors.other = '';
                }
              }}
              value={other}
              hidden={false}
              required
            />
          ) : (
            <input
              id="other"
              className="ecr-input"
              name="other"
              maxLength="50"
              onChange={(e) => {
                if (!/[^a-zA-Z]/.test(e.target.value)) {
                  setOther(e.target.value);
                  errors.other = '';
                }
              }}
              value={other}
              hidden
            />
          )}
          <span style={{ color: 'red', fontSize: 12 }}>
            {errors.other}
          </span>
        </div>
      </div> */}

        <div className="column column_full">
          <div className="left_input">
            <h3>Comments</h3>
            <h6>
              If you have any questions or comments
              please don&apos;t hesitate to contact us.
            </h6>
            <textarea
              id="comments"
              name="comments"
              maxLength="250"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
          <div className="right_input">
            <div className="alt_phone_div">
              <h3>Alternate Phone</h3>
              <div>
                <PhoneInput
                  dropdownStyle={{ overflow: 'overlay', width: 'max-content' }}
                  inputStyle={{ width: '-webkit-fill-available' }}
                  onlyCountries={['us']}
                  country="us"
                  disableCountryCode
                  value={alternatePhone}
                  onChange={onChangeAlternatePhone}
                  placeholder="(xxx) xxx-xxxx"
                />
              </div>
              {errors.alternatePhone && (
              <span style={{ color: 'red', fontSize: 12 }}>
                {errors.alternatePhone}
              </span>
              )}
            </div>
            <div className="rel_time_div">
              <h3>
                Release Time
                {' '}
                <span
                  className="required"
                  style={{ color: 'red', fontSize: 12 }}
                >
                  *
                </span>
              </h3>
              {/* <TimePicker
                use12Hours
                format="h:mm a"
                onChange={onChangeReleseTime}
              /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                  <TimePicker
                    className="Time-picker"
                    value={releaseTime}
                    onChange={onChangeReleseTime}
                    renderInput={(params) => <TextField {...params} placeholder="hh:mm (a|p)m" />}
                  />
                </Stack>
              </LocalizationProvider>
              {errors.releaseTime && (
              <span style={{ color: 'red', fontSize: 12 }}>
                {errors.releaseTime}
              </span>
              )}
            </div>
          </div>
        </div>

        <button
          id="submit_btn"
          type="submit"
          onClick={handleSubmitForm}
          className="early-leave-btn"
        >
          {submitLoading ? <LoadingIndicator /> : 'Submit'}
        </button>
        {submitError && (
        <p className="showErrorMsgAtSubmit">
          {submitError}
        </p>
        )}
      </form>
    </section>
  );
};

export default Form;
